import script from "./CheckoutPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutPage.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutPage.vue?vue&type=style&index=0&id=f201575e&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f201575e"]])

export default __exports__